// ======================================================================
// File Name       : ThumbNail
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import NoImage from '../../images/no-image-icon.png';
import RenderField from '../../utils/ReduxFormUtils';
import { downloadThumbnail, hasProperty } from '../../utils/index';

class ThumbNail extends React.Component {
  render() {
    const { handleImageFileChange, formValues, onChangeCheckbox, isOEMUser } = this.props;
    const acceptFile = 'image/png';
    let $imagePreview = <img alt="150x150" height="150" width="150" src={NoImage} />;
    let thumbnailPreview = null;
    let changed = false;
    const animateIcon = (
      <i
        role="button"
        className="bi bi-arrow-clockwise refresh-animate"
      />
    );

    if (formValues && Object.keys(formValues).length) {
      thumbnailPreview = Object.keys(formValues).map((childKey) => {
        changed = formValues[childKey].changed;
        if (
          hasProperty(formValues[childKey], 'thumbnailUrlFileLoad')
        ) {
          $imagePreview = (
            <img
              className="img"
              alt="150x150"
              height="150"
              width="150"
              src={formValues[childKey].thumbnailUrlFileLoad || NoImage}
            />
          );
        } else if (
          formValues[childKey].dataUrl === undefined
        ) {
          $imagePreview = (
            animateIcon
          );
        } else if (
          formValues[childKey].userfrontImageUrl &&
          formValues[childKey].userfrontImageUrl !== '' &&
          formValues[childKey].dataUrl &&
          formValues[childKey].dataUrl !== ''
        ) {
          $imagePreview = (
            <img
              alt="150x150"
              height="150"
              width="150"
              className="img cursor_pointer"
              src={formValues[childKey].dataUrl}
              onClick={() => downloadThumbnail(formValues[childKey].userfrontImageUrl)}
            />
          );
        } else {
          $imagePreview = <img alt="150x150" height="150" width="150" src={NoImage} />;
        }

        let isEnableFileUpload = true;
        if (hasProperty(formValues[childKey], 'isEnableFileUpload')) {
          isEnableFileUpload = formValues[childKey].isEnableFileUpload;
        }

        const { isManualFileUpload } = formValues[childKey];

        return (
            <Form.Group className="form-info" key={childKey}>
              <Col sm={12} className="padding-left-right-clear">
                <Col as={Form.Label} sm={2}>
                  {formValues[childKey].titleName}
                </Col>
              </Col>
              <Col sm={12} className="padding-left-right-clear display-flex">
                <Col className="margin-left-15 margin-bottom-8" sm={2}>{$imagePreview}</Col>
                <Col sm={7} className="label-middle">
                  <Col sm={12}>
                    <Col sm={3} className="padding-left-right-clear">
                      <RenderField
                        type="file"
                        accept={acceptFile}
                        name={`${childKey}.imageFileUpload`}
                        label="ファイルを選択"
                        changeFile={handleImageFileChange}
                        disabled={!isManualFileUpload}
                      />
                    </Col>
                    {/* Step 10.3.0 START */}
                    {!isOEMUser && (
                      <Col sm={4} className="padding-left-right-clear margin-top-7">
                        <RenderField
                          type="checkbox"
                          name={`${childKey}.imageCheckBoxType`}
                          label="初期画像に戻す"
                          normalizeRadio
                          checkRadioChange
                          radioChange={onChangeCheckbox}
                          disabled={!isEnableFileUpload}
                        />
                      </Col>
                    )}
                    {/* Step 10.3.0 END */}
                  </Col>
                </Col>
              </Col>
            </Form.Group>
        );
      });
    }
    return (
      <div className="form-horizontal">
        {thumbnailPreview}
      </div>
    );
  }
}

export default ThumbNail;
